<template>
  <el-dialog v-if="visible" title="查看计划" class="avue-dialog avue-dialog--top" top="-10vh" width="80%" append-to-body
             destroy-on-close :close-on-click-modal="false" :visible.sync="visible">
    <div style="min-height: 120px; padding-top: 10px;">
      <dispatchCenter v-if="visible" :planNo="chooseOne.planNo" :isComponents="true"></dispatchCenter>
    </div>
<!--    <div class="avue-dialog__footer">-->
<!--      <el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>-->
<!--      <el-button @click="visible = false">取消</el-button>-->
<!--    </div>-->
  </el-dialog>
</template>

<script>
import dispatchCenter from '@/views/basic-info/dispatchCenter/index.vue'
import { userSelect, userInsert } from './api'

export default {
  name: "train-import",
  components: {
    dispatchCenter
  },
  props:{
    chooseOne:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      isHGZ:null,
      visible: false,
      loading: false,
      form: {
        value:''
      },
      fileList: [],
      userOptions:[],
      option: {
        span: 24,
        menuBtn: false,
        filterDic: true,
        filterNull: true,
        column: [
          {
            label: '过车时间',
            prop: 'importTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: "股道",
            prop: "poundno",
            type: "select",
            dicUrl: `${this.baseDicUrl}/${this.isHGZ ? 'hgz_poundno_code' : 'jtg_poundno_dx'}`,
            props: this.dicProps,
            filterable: true,
            value: this.isHGZ ? '001' : '002',
            clearable: false,
            rules: [
              {
                required: true,
                message: "请选择股道",
                trigger: "blur",
              }
            ]
          },
          {
            label: '来车方向',
            prop: 'direction',
            type: 'select',
            dicUrl: `${this.baseDicUrl}/direction`,
            props: this.dicProps,
            filterable: true,
            value: '3',
            clearable: false,
          },
          {
            label: '附件',
            prop: 'upload',
          },
        ]
      }
    }
  },
  methods: {

    getUserInfo(){
      userSelect().then(res=>{
        if(res.data.code == 200){
          this.userOptions = res.data.data.records
        }

      })
    },
    onSubmit() {
      console.log(this.chooseOne)
      userInsert({
        teamId:this.chooseOne.id,
        teamNo:this.chooseOne.teamNo,
        teamName:this.chooseOne.teamName,
        teamMemberId:this.userOptions[this.form.value].id,
        teamMemberName:this.userOptions[this.form.value].name,
      }).then(res=>{
        if(res.data.code == 200){
          this.$message({
            type:"success",
            message:"添加成功"
          })
          this.visible = false
        }
      })
    },

  },
  mounted() {
    // this.getUserInfo()

  },
  watch: {
    visible(val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data.call(this))
        // this.getUserInfo()
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
